<div class="all-documents-toolbar d-none d-md-flex flex-column gap-3 mb-4 w-100">
  <!-- Quota: full-width row so it doesn’t compete with empty space beside the title -->
  <div *ngIf="!canCreateDocument" class="all-documents-toolbar__quota w-100">
    <div class="quota-exceeded-notice quota-exceeded-notice--full-width" role="status">
      <div class="quota-exceeded-notice__icon" aria-hidden="true">
        <i class="pi pi-lock"></i>
      </div>
      <div class="quota-exceeded-notice__body">
        <p class="quota-exceeded-notice__title">
          {{
            curentLang === 'ar'
              ? 'وصلت للحد الأقصى للفواتير'
              : curentLang === 'he'
                ? 'הגעת למגבלת המסמכים'
                : 'Document limit reached'
          }}
        </p>
        <p class="quota-exceeded-notice__hint">
          {{
            curentLang === 'ar'
              ? 'ترقِ خطتك أو أضف مستندات للمتابعة.'
              : curentLang === 'he'
                ? 'שדרג או הוסף מסמכים כדי להמשיך.'
                : 'Upgrade or add documents to continue.'
          }}
        </p>
      </div>
      <a [routerLink]="['/dashboard/invoice-subscriptions']" class="quota-exceeded-notice__cta">
        {{
          curentLang === 'ar'
            ? 'ترقية الخطة'
            : curentLang === 'he'
              ? 'שדרג תוכנית'
              : 'Upgrade plan'
        }}
        <i class="pi pi-arrow-up-right quota-exceeded-notice__cta-icon" aria-hidden="true"></i>
      </a>
    </div>
  </div>

  <div class="all-documents-toolbar__row d-flex flex-wrap align-items-center justify-content-between gap-2 w-100">
    <div class="all-documents-toolbar__primary d-flex flex-wrap align-items-center gap-2">
      <div class="position-relative d-inline-block actions-new-document" *ngIf="canCreateDocument">
        <p-menu #newDocument [popup]="true" [model]="documentTypesMenu"></p-menu>
        <button pButton pRipple [label]="'allDocuments.actions.newDocument' | translate" icon="pi pi-file" iconPos="left"
          class="p-button-lg p-button-raised" (click)="newDocument.toggle($event)"></button>
      </div>
      <button pButton pRipple type="button"
        [label]="(isPdfExporting ? 'allDocuments.actions.exportingPdf' : 'allDocuments.actions.exportPdf') | translate"
        [icon]="isPdfExporting ? 'pi pi-spin pi-spinner' : 'pi pi-download'" iconPos="left"
        class="all-documents-toolbar__pdf-btn p-button-lg p-button-raised p-button-secondary"
        (click)="onExportPdf()"
        [disabled]="isPdfExporting"></button>
    </div>
    <div class="all-documents-toolbar__secondary d-flex flex-wrap align-items-center gap-2">
      <button pButton pRipple type="button" [label]="'allDocuments.actions.resetColumns' | translate" icon="pi pi-sort-alt-slash" iconPos="left"
        class="p-button-outlined p-button-info" (click)="onResetColumns()"
        *ngIf="showResetColumnsButton"></button>
      <button *ngIf="activeFiltersCount !== 0" pButton pRipple type="button"
        [label]="('allDocuments.actions.clearFilters' | translate) + ' ' + activeFiltersCount + ' ' + ('allDocuments.actions.filters' | translate)"
        icon="pi pi-filter-slash" iconPos="left" class="p-button-outlined p-button-danger"
        (click)="onClearFilters()"></button>
    </div>
  </div>
</div>

<!-- Mobile: full-width quota banner (desktop row is d-none on small screens) -->
<div *ngIf="!canCreateDocument" class="quota-mobile-banner d-md-none" role="status">
  <div class="quota-mobile-banner__icon" aria-hidden="true">
    <i class="pi pi-lock"></i>
  </div>
  <div class="quota-mobile-banner__body">
    <p class="quota-mobile-banner__title">
      {{
        curentLang === 'ar'
          ? 'وصلت للحد الأقصى للفواتير'
          : curentLang === 'he'
            ? 'הגעת למגבלת המסמכים'
            : 'Document limit reached'
      }}
    </p>
    <p class="quota-mobile-banner__hint">
      {{
        curentLang === 'ar'
          ? 'ترقِ خطتك أو أضف مستندات للمتابعة.'
          : curentLang === 'he'
            ? 'שדרג או הוסף מסמכים כדי להמשיך.'
            : 'Upgrade or add documents to continue.'
      }}
    </p>
    <a [routerLink]="['/dashboard/invoice-subscriptions']" class="quota-mobile-banner__cta">
      {{
        curentLang === 'ar'
          ? 'ترقية الخطة'
          : curentLang === 'he'
            ? 'שדרג תוכנית'
            : 'Upgrade plan'
      }}
      <i class="pi pi-arrow-up-right quota-mobile-banner__cta-icon" aria-hidden="true"></i>
    </a>
  </div>
</div>

<p-speedDial class="speed-dial d-md-none" [model]="mobileDocumentsActions" radius="160" direction="up-left" type="quarter-circle"></p-speedDial>

<!-- Mobile Document Type Selection Dialog -->
<p-dialog [(visible)]="displayDocumentTypeDialog" [modal]="true" [style]="{width: '90%', maxWidth: '650px'}"
  [draggable]="false" [resizable]="false" [header]="'allDocuments.actions.newDocument' | translate" [closeOnEscape]="true"
  styleClass="document-type-dialog">

  <p>{{ 'allDocuments.actions.selectDocumentType' | translate }}</p>

  <div class="document-type-container">
    <div *ngFor="let docType of documentTypes" class="document-type-item d-flex align-items-center p-3 mb-2 border rounded"
      (click)="selectDocumentType(docType)" style="cursor: pointer; transition: background-color 0.2s;">
      <div class="document-icon me-3">
        <i [class]="docType.icon" style="font-size: 24px; color: #007bff;"></i>
      </div>
      <div class="document-details flex-grow-1">
        <h5 class="mb-1">{{ docType.label | translate }}</h5>
        <p *ngIf="docType.description" class="mb-0 text-muted small">{{ docType.description | translate }}</p>
      </div>
      <i class="pi pi-chevron-right text-muted"></i>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" icon="pi pi-times" label="{{ 'modal.common.close' | translate }}"
      class="p-button-secondary" (click)="closeDocumentTypeDialog()"></button>
  </ng-template>
</p-dialog>

